import React, { useRef, useEffect, useState } from 'react';
import './commodities.scss';
import Combobox, { MenuItem } from '@ingka/combobox';
import InputField from '@ingka/input-field';
import Tabs, { Tab, TabPanel } from '@ingka/tabs';
import styled from 'styled-components';
import './commodities.scss';
import Button from '@ingka/button';
import { Select, Option } from '@ingka/select';
import FormField from '@ingka/form-field';
import { masterDataManual } from 'Action/manualDropDownAction';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'Store/store';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/forms/dist/style.css';
import Accordion, { AccordionItem } from '@ingka/accordion';
import Products from 'pages/Products/products';
import { addCommodityRow, updateCommodityRows } from 'Action/commodityDetailsStateAction';
import DatePickerComponent from 'pages/DatePickerComponent/datePickerComponent';
import { setCommodityRows } from 'Action/commodityDetailsStateAction';
import Pill from '@ingka/pill';
import crossCircle from '@ingka/ssr-icon/paths/cross-circle';

const CommoditiesDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 5px;
`;

const Commodities = (props: any) => {
  const { productRows, setProductRows } = props;
  const [shouldValidateArea, setShouldValidateArea] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const { masterData } = useSelector((state: RootState) => state.dropDownMasterData);
  const { commodityFieldRows } = useSelector((state: RootState) => state.commodityState);

  useEffect(() => {
    dispatch(masterDataManual());
  }, []);

  const handleAddProducer = (
    commodityIndex: number,
    accordionIndex: number,
    rowIndex: number,
    field: string,
    value: any,
    event: any
  ) => {
    const updatedCommodityRows = commodityFieldRows.map((commodity, cIndex) => {
      if (cIndex !== commodityIndex) return commodity;

      const updatedAccordions = commodity.producerAccordions.map((accordion, aIndex) => {
        if (aIndex !== accordionIndex) return accordion;

        const updatedProducerRows = accordion.producerRows.map((row, rIndex) => {
          if (rIndex !== rowIndex) return row;
          return { ...row, [field]: value };
        });

        return { ...accordion, producerRows: updatedProducerRows };
      });

      return { ...commodity, producerAccordions: updatedAccordions };
    });

    dispatch(setCommodityRows(updatedCommodityRows));
  };

  const handlePlaceChange = (
    commodityIndex: number,
    accordionIndex: number,
    placeRowIndex: number,
    field: string,
    value: any,
    event: any
  ) => {
    if (field === 'harvestValidTo' && value instanceof Date) {
      value = value.toISOString();
    }
    if (field === 'harvestValidFrom' && value instanceof Date) {
      value = value.toISOString();
    }

    const updatedCommodityRows = commodityFieldRows.map((commodity, cIndex) => {
      if (cIndex !== commodityIndex) return commodity;

      const updatedAccordions = commodity.producerAccordions.map((accordion, aIndex) => {
        if (aIndex !== accordionIndex) return accordion;

        const updatedPlaces = accordion.productionPlaceRows.map((row, rIndex) => {
          if (rIndex !== placeRowIndex) return row;
          return { ...row, [field]: value };
        });

        return { ...accordion, productionPlaceRows: updatedPlaces };
      });

      return { ...commodity, producerAccordions: updatedAccordions };
    });

    dispatch(setCommodityRows(updatedCommodityRows));
  };

  const handleAddProducerRow = (commodityIndex: number) => {
    const updatedRows = commodityFieldRows.map((commodity, index) => {
      if (index !== commodityIndex) return commodity;

      const newAccordion = {
        producerRows: [{ producerName: '', producerCountry: '' }],
        productionPlaceRows: [
          {
            productionPlace: '',
            type: '',
            coordinates: '',
            area: '',
            id: null,
            harvestValidFrom: '',
            harvestValidTo: '',
          },
        ],
      };

      return {
        ...commodity,
        producerAccordions: [...(commodity.producerAccordions || []), newAccordion],
      };
    });

    dispatch(setCommodityRows(updatedRows));
  };

  const handleInputChange = (index: number, field: string, value: any, event: any) => {
    const updatedRows = commodityFieldRows.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );

    if (field === 'hsHeader') {
      const selectedCommodity = masterData?.commodityMaster.find(
        (commodity) => commodity.hsCode === event.target.value
      );
      updatedRows[index].descriptionOfGoods = selectedCommodity?.eudrDesc || '';
    }

    dispatch(setCommodityRows(updatedRows));
  };

  const handleAddProducionPlaceRow = (commodityIndex: number, accordionIndex: number) => {
    const updatedRows = commodityFieldRows.map((commodity, cIndex) => {
      if (cIndex !== commodityIndex) return commodity;

      const updatedAccordions = commodity.producerAccordions.map((accordion, aIndex) => {
        if (aIndex !== accordionIndex) return accordion;

        return {
          ...accordion,
          productionPlaceRows: [
            ...accordion.productionPlaceRows,
            {
              productionPlace: '',
              type: '',
              coordinates: '',
              area: '',
              harvestValidFrom: '',
              harvestValidTo: '',
              id: null,
            },
          ],
        };
      });

      return {
        ...commodity,
        producerAccordions: updatedAccordions,
      };
    });

    dispatch(setCommodityRows(updatedRows));
  };
  const handleDeleteProductionPlaceRow = (
    commodityIndex: number,
    accordionIndex: number,
    rowIndex: number
  ) => {
    const updatedRows = commodityFieldRows.map((commodity, cIndex) => {
      if (cIndex !== commodityIndex) return commodity;

      const updatedAccordions = commodity.producerAccordions.map((accordion, aIndex) => {
        if (aIndex !== accordionIndex) return accordion;

        const updatedProductionPlaceRows = accordion.productionPlaceRows.filter(
          (_, rIndex) => rIndex !== rowIndex
        );

        return {
          ...accordion,
          productionPlaceRows: updatedProductionPlaceRows,
        };
      });

      return {
        ...commodity,
        producerAccordions: updatedAccordions,
      };
    });

    dispatch(setCommodityRows(updatedRows));
  };

  const handleAddCommodityRow = () => {
    const newCommodityRow = {
      hsHeader: '',
      descriptionOfGoods: '',
      productId: '',
      itemSupplier: '',
      gtin: '',
      netWeight: '',
      volume: '',
      numberofUnits: '',
      universalUnit: null,
      validFrom: '',
      validUntil: '',
      producerAccordions: [
        {
          producerRows: [{ producerName: '', producerCountry: '' }],
          productionPlaceRows: [
            {
              productionPlace: '',
              type: '',
              coordinates: '',
              area: '',
              harvestValidFrom: '',
              harvestValidTo: '',
              id: null,
            },
          ],
        },
      ],
    };

    const updatedRows = [...commodityFieldRows, newCommodityRow];
    dispatch(setCommodityRows(updatedRows));
  };

  const accordions = (
    <div>
      <div className="commodity" style={{ height: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleAddCommodityRow} size="xsmall">
            Add Commodities
          </Button>
        </div>
        <Accordion key="tab-4" title="Commodities" id="tab_4">
          {Array.isArray(commodityFieldRows) &&
            commodityFieldRows.map((row, commodityIndex) => (
              <AccordionItem
                id={`tab_4_${commodityIndex}`}
                title={`Commodities-${commodityIndex + 1}`}
                open={true}
                key={`commodity-accordion-${commodityIndex}`}
              >
                <div className="commodity-tabs">
                  <Products setProductRows={setProductRows} productRows={productRows} />
                  <CommoditiesDiv>
                    <Select
                      style={{ minWidth: 'max-content' }}
                      id={`hscode-${commodityIndex}`}
                      label="HS Header"
                      value={row.hsHeader}
                      onChange={(e) =>
                        handleInputChange(commodityIndex, 'hsHeader', e.target.value, e)
                      }
                    >
                      {masterData?.commodityMaster &&
                        masterData.commodityMaster.map((commodity) => (
                          <Option
                            key={commodity.hsCode}
                            value={commodity.hsCode}
                            name={commodity.hsCode}
                          />
                        ))}
                    </Select>
                    <InputField
                      label="Description Of Goods"
                      iconPosition="leading"
                      id={`description-${commodityIndex}`}
                      type="text"
                      className="description"
                      value={row.descriptionOfGoods}
                      placeholder="Description of goods"
                      onChange={(e) =>
                        handleInputChange(commodityIndex, 'descriptionOfGoods', e.target.value, e)
                      }
                    />
                  </CommoditiesDiv>
                  <div className="quantity-tabs">
                    <FormField
                      style={{ display: 'flex', marginBottom: 0, gap: 10 }}
                      // shouldValidate={shouldValidate}
                      // valid={shouldValidate ? 'error' : false}
                      validation={{
                        id: 'error-msg-id',
                        msg: 'Either Net Weight Or Volume Must Be Provided',
                        type: 'error',
                      }}
                    >
                      <InputField
                        label="Net Weight"
                        iconPosition="leading"
                        id={`net-weight-${commodityIndex}`}
                        type="number"
                        style={{ marginRight: 10 }}
                        value={row.netWeight}
                        placeholder="NetWeight(kg)"
                        onChange={(e) =>
                          handleInputChange(commodityIndex, 'netWeight', e.target.value, e)
                        }
                      />
                      <InputField
                        label="Volume(m3)"
                        iconPosition="leading"
                        id={`volume-${commodityIndex}`}
                        type="number"
                        style={{ marginRight: 10 }}
                        value={row.volume}
                        placeholder="productname"
                        onChange={(e) =>
                          handleInputChange(commodityIndex, 'volume', e.target.value, e)
                        }
                      />
                    </FormField>

                    {/* <div style={{ position: 'relative' }}> */}
                    <InputField
                      label="Number Of Units"
                      iconPosition="leading"
                      id={`number-${commodityIndex}`}
                      type="number"
                      style={{ marginRight: 10 }}
                      value={row.numberofUnits}
                      onChange={(e) =>
                        handleInputChange(commodityIndex, 'numberofUnits', e.target.value, e)
                      }
                      // onFocus={() => setShowPlaceholder(false)}
                    />
                    {/* </div> */}
                    <Select
                      id={`unitId-${commodityIndex}`}
                      label="Universal Unit Type"
                      value={row.universalUnit || null}
                      onChange={(e) =>
                        handleInputChange(commodityIndex, 'universalUnit', e.target.value, e)
                      }
                    >
                      {masterData?.universalUnitTypeMaster &&
                        masterData.universalUnitTypeMaster.map((data) => (
                          <Option
                            key={data.unitTypeCode}
                            value={data.unitTypeCode}
                            name={data.unitTypeCode}
                          />
                        ))}
                    </Select>
                  </div>
                </div>
                <div className="producer-accordion">
                  {row.producerAccordions?.map((accordion, accordionIndex) => (
                    <Accordion key={accordionIndex}>
                      <AccordionItem
                        id={`producer-id-${accordionIndex}`}
                        onHeadingClicked={() => {}}
                        title={`Producer ${accordionIndex + 1}`}
                        open
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          {/* <span>Producers {accordionIndex + 1}</span> */}
                          <Button
                            onClick={() => handleAddProducerRow(commodityIndex)}
                            size="xsmall"
                          >
                            Add Producer
                          </Button>
                        </div>

                        {accordion.producerRows.map((producerRow, rowIndex) => (
                          <div
                            key={accordionIndex}
                            style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '70%',
                                gap: 16,
                              }}
                            >
                              <InputField
                                label="Producer Name"
                                iconPosition="leading"
                                id={`producer-name-${commodityIndex}-${rowIndex}`}
                                type="text"
                                style={{ marginRight: 10, width: 100 }}
                                value={producerRow.producerName}
                                onChange={(e) =>
                                  handleAddProducer(
                                    commodityIndex,
                                    accordionIndex,
                                    rowIndex,
                                    'producerName',
                                    e.target.value,
                                    e
                                  )
                                }
                              />
                              <Select
                                id={`countryId-${commodityIndex}-${rowIndex}`}
                                label="Country"
                                value={producerRow.producerCountry}
                                style={{ maxHeight: 100, width: '100' }}
                                onChange={(e) =>
                                  handleAddProducer(
                                    commodityIndex,
                                    accordionIndex,
                                    rowIndex,
                                    'producerCountry',
                                    e.target.value,
                                    e
                                  )
                                }
                              >
                                {masterData?.countryMaster &&
                                  masterData.countryMaster.map((data) => (
                                    <Option
                                      key={data.countryName}
                                      value={data.countryCode}
                                      name={data.countryName}
                                    />
                                  ))}
                              </Select>
                            </div>
                            <div className="production-Place">
                              <Accordion className="production-place-accordion">
                                <AccordionItem
                                  id={`production-place-id-${commodityIndex}-${accordionIndex}`}
                                  onHeadingClicked={() => {}}
                                  title="Production Place"
                                  open
                                >
                                  <div style={{ marginTop: 10 }}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                      <Button
                                        onClick={() =>
                                          handleAddProducionPlaceRow(commodityIndex, accordionIndex)
                                        }
                                        size="xsmall"
                                      >
                                        Add Production Place
                                      </Button>
                                    </div>
                                  </div>
                                  {accordion.productionPlaceRows.map((placeRow, placeRowIndex) => (
                                    <div
                                      key={placeRowIndex}
                                      style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
                                    >
                                      <div className="production-place-row">
                                        {/* <div className="row"> */}
                                        <div className="productionplace" style={{ width: 116 }}>
                                          <InputField
                                            label="Production place"
                                            iconPosition="leading"
                                            id={`production-place-${placeRowIndex}`}
                                            type="text"
                                            value={placeRow.productionPlace}
                                            onChange={(e) =>
                                              handlePlaceChange(
                                                commodityIndex,
                                                accordionIndex,
                                                placeRowIndex,
                                                'productionPlace',
                                                e.target.value,
                                                e
                                              )
                                            }
                                          />
                                        </div>
                                        <div
                                          className="geojsonfield"
                                          style={{ width: 'max-content' }}
                                        >
                                          <Select
                                            id={`geoId-${commodityIndex}-${accordionIndex}-${placeRowIndex}`}
                                            label="Geo Json type"
                                            value={placeRow.type || ''}
                                            onChange={(e) =>
                                              handlePlaceChange(
                                                commodityIndex,
                                                accordionIndex,
                                                placeRowIndex,
                                                'type',
                                                e.target.value,
                                                e
                                              )
                                            }
                                          >
                                            {masterData?.geoJsonTypeMaster &&
                                              masterData?.geoJsonTypeMaster.map((geojsontype) => (
                                                <Option
                                                  key={geojsontype.geoJsonType}
                                                  value={geojsontype.geoJsonType}
                                                  name={geojsontype.geoJsonType}
                                                />
                                              ))}
                                          </Select>
                                        </div>
                                        {/* </div> */}
                                        <div className="coordinates-field">
                                          <InputField
                                            label="Geo Json coordinates"
                                            iconPosition="leading"
                                            id={`coordinates-${commodityIndex}-${accordionIndex}-${placeRowIndex}`}
                                            type="text"
                                            value={placeRow.coordinatesString || ''}
                                            onChange={(e) =>
                                              handlePlaceChange(
                                                commodityIndex,
                                                accordionIndex,
                                                placeRowIndex,
                                                'coordinatesString',
                                                e.target.value,
                                                e
                                              )
                                            }
                                          />
                                        </div>

                                        <FormField
                                          shouldValidate={shouldValidateArea}
                                          valid={shouldValidateArea ? 'error' : false}
                                          validation={{
                                            id: 'error-msg-id',
                                            msg: 'Area is required for point coordinates and cannot exceed 4',
                                            type: 'error',
                                          }}
                                        >
                                          <div className="row">
                                            <div className="field coordinates-field">
                                              <InputField
                                                label="Area"
                                                iconPosition="leading"
                                                id={`area-${commodityIndex}-${accordionIndex}-${placeRowIndex}`}
                                                type="number"
                                                style={{ width: 56 }}
                                                value={placeRow.area || ''}
                                                placeholder="Area"
                                                onChange={(e) =>
                                                  handlePlaceChange(
                                                    commodityIndex,
                                                    accordionIndex,
                                                    placeRowIndex,
                                                    'area',
                                                    e.target.value,
                                                    e
                                                  )
                                                }
                                              />
                                            </div>

                                            <div className="harvestvalidfield">
                                              <div className="field datepicker-wrapper">
                                                <DatePickerComponent
                                                  heading="Harvest valid from"
                                                  selectedDate={
                                                    placeRow.harvestValidFrom
                                                      ? new Date(placeRow.harvestValidFrom)
                                                      : null
                                                  }
                                                  format="date"
                                                  onChange={(formattedDate) =>
                                                    handlePlaceChange(
                                                      commodityIndex,
                                                      accordionIndex,
                                                      placeRowIndex,
                                                      'harvestValidFrom',
                                                      formattedDate,
                                                      ''
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div className="harvestvalidtofield">
                                              <div className="field datepicker-wrapper">
                                                <DatePickerComponent
                                                  heading=" Harvest valid until"
                                                  selectedDate={
                                                    placeRow.harvestValidTo
                                                      ? new Date(placeRow.harvestValidTo)
                                                      : null
                                                  }
                                                  format="date"
                                                  onChange={(formattedDate) =>
                                                    handlePlaceChange(
                                                      commodityIndex,
                                                      accordionIndex,
                                                      placeRowIndex,
                                                      'harvestValidTo',
                                                      formattedDate,
                                                      ''
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <Pill
                                              size="xsmall"
                                              onClick={() =>
                                                handleDeleteProductionPlaceRow(
                                                  commodityIndex,
                                                  accordionIndex,
                                                  placeRowIndex
                                                )
                                              }
                                              leadingIcon={crossCircle}
                                            />
                                          </div>
                                        </FormField>
                                      </div>
                                    </div>
                                  ))}
                                </AccordionItem>
                              </Accordion>
                            </div>
                          </div>
                        ))}
                      </AccordionItem>
                    </Accordion>
                  ))}
                </div>
              </AccordionItem>
            ))}
        </Accordion>
        <div style={{ marginLeft: 20 }}></div>
      </div>
    </div>
  );
  return <div>{accordions}</div>;
};

export default Commodities;
